const _ = require('underscore');
const Q = require('q');
const moment = require('moment');
const model = require('model/model');
const assignmentService = require('services/assignmentService');
const assignmentUtilities = require('utilities/assignmentUtilities');
const classUtilities = require('utilities/classUtilities');

const STATUS_ACTIVE = assignmentUtilities.STATUS.ACTIVE;
const STATUS_FUTURE = assignmentUtilities.STATUS.FUTURE;
const STATUS_DONE = assignmentUtilities.STATUS.DONE;

// Current survey's end date
const currentSurveyEndDate = moment('20200627').subtract(1, 'second').toDate().getTime();
// Current survey's start date
const currentSurveyStartDate = moment('20200519').subtract(1, 'second').toDate().getTime();

const VERSION_MAP = {
	'34_A': 'B',
	'34_B': 'A',
	'56_A': 'B',
	'56_B': 'A'
};

// const VALID_CVA_GRADES = {
// 	'19': true,
// 	'20': true,
// 	'21': true,
// 	'22': true
// };

const addTwentyFourHours = date => {
	return moment(date).add(1, 'day').toDate().getTime();
};

const getSurveyStatus = survey => {
	let now = new Date().getTime();
	let status = null;
	if (survey.d * 1000 > now) {
		status = STATUS_FUTURE;
	} else if (survey.d * 1000 <= now && addTwentyFourHours(survey.d * 1000) > now) {
		status = STATUS_ACTIVE;
	} else {
		status = STATUS_DONE;
	}
	return status;
};

const getCVAProduct = () => {
	return assignmentService.getCvaProduct().then(product => {
		model.set('cvaProduct', _.assign({}, product));
		return product;
	});
};

const getCVAAssignments = () => {
	return assignmentService.teacherGetCvaAssignments().then(assignments => {
		// Convert to map by class code
		let cvaAssignments = (assignments || []).reduce((acc, a) => {
			let s = getSurveyStatus(a);
			let assignment = _.assign({}, a, {
				s
			});

			acc[assignment.cc] = assignment;

			return acc;
		}, {});
		model.set('cvaAssignments', _.assign({}, cvaAssignments));

		return cvaAssignments;
	});
};

const getCVAEligibleClasses = () => {
	return Q.all([getCVAAssignments(), assignmentService.getCVAEligibleClasses(), classUtilities.loadActiveClasses()]).then(prms => {
		let previousCVAAssignments = prms.length ? prms[1] : null;
		let cvaAssignments = model.get('cvaAssignments');
		let previousCVAMap = previousCVAAssignments.reduce((acc, p) => {
			acc[p.cc] = p.v;
			return acc;
		}, {});
		let activeClasses = model.get('activeClasses');
		let cvaEligbleClasses = activeClasses.filter(c => previousCVAMap[c.classCode] && !cvaAssignments[c.classCode]);

		model.set('previousCVAAssignments', previousCVAMap);
		model.set('cvaEligbleClasses', [...cvaEligbleClasses]);
	});
};

// const updateEligibleClasses = () => {
// 	let activeClasses = model.get('activeClasses');
// 	let cvaAssignments = model.get('cvaAssignments');
// 	let cvaEligbleClasses = [];

// 	if (activeClasses && activeClasses.length) {
// 		cvaEligbleClasses = activeClasses.filter(c => {
// 			return VALID_CVA_GRADES[c.grade] && !cvaAssignments[c.classCode];
// 		});
// 	}

// 	model.set('cvaEligbleClasses', [...cvaEligbleClasses]);
// 	return cvaEligbleClasses;
// };

// const getCVAEligibleClasses = () => {
// 	return getCVAAssignments().then(cvaAssignments => {
// 		return classUtilities.loadActiveClasses()
// 			.then(activeClasses => {
// 				return updateEligibleClasses();
// 			});
// 	});
// };

const createCVAAssignment = data => {
	let previousCVAMap = model.get('previousCVAAssignments');
	let previousVersion = previousCVAMap[data.cc];

	data.group = previousVersion ? VERSION_MAP[previousVersion] : null;
	// data.group = userContext.getExperimentGroup();

	return assignmentService.createCvaAssignment(data).then(survey => {
		let cvaAssignments = model.get('cvaAssignments');

		// Update cvaAssignments
		cvaAssignments = _.assign({}, cvaAssignments, {
			[survey.cc]: survey
		});
		model.set('cvaAssignments', cvaAssignments);

		return getCVAEligibleClasses();
	});
};

const deleteCVAAssignment = cc => {
	return assignmentService
		.deleteCvaAssignment({
			cc
		})
		.then(() => {
			let cvaAssignments = model.get('cvaAssignments');

			// remove deleted cva from model
			cvaAssignments = Object.keys(cvaAssignments).reduce((acc, key) => {
				if (key !== cc) {
					acc[key] = cvaAssignments[key];
				}
				return acc;
			}, {});
			model.set('cvaAssignments', _.assign({}, cvaAssignments));

			// Recalc eligible classes
			getCVAEligibleClasses();

			return cvaAssignments;
		});
};

const studentGetCVAAssignment = () => {
	return assignmentService.studentGetCvaAssignment().then(assignment => {
		if (!assignment) {
			return null;
		}

		// Ensure status is active before storing
		let s = getSurveyStatus(assignment);
		if (s !== STATUS_ACTIVE) {
			return null;
		}

		// Student has active CVA
		assignment = _.assign({}, assignment, {
			s
		});
		model.set('studentCVAAssignment', _.assign({}, assignment));
		return assignment;
	});
};

const studentSubmitCVAAssignment = ans => {
	return assignmentService
		.studentSubmitCvaAssignment({
			ans
		})
		.then(() => {
			model.remove('studentCVAAssignment');
		});
};

module.exports = {
	getCVAProduct,
	getCVAAssignments,
	createCVAAssignment,
	getCVAEligibleClasses,
	deleteCVAAssignment,
	studentGetCVAAssignment,
	studentSubmitCVAAssignment,
	currentSurveyEndDate,
	currentSurveyStartDate,
	getSurveyStatus
};
